<template>
  <div id="func-10">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
      :voltar="!isWidget"
    />
      <div class="main">
        <solicitacao-listagem
          :chave-externa="'extrato'"
          :funcionalidade="funcionalidade"
          :lista-externa="listaComData"
          :rota-novo="rotaNovo"
          :rota-historico="rotaHistorico"
          :rota-detalhe="rotaDetalhe"
          :permite-nova-solicitacao="funcionalidade.parametros.permiteNovoReembolso"
        >
          <template v-slot:default="{card}">
            <div
              @click="onClickRow(card)"
            >
              <ListaExtratoCard
                :card="card"
                :showWidgetActions="showWidgetActions"
                :preloadWidget="() => carregaPayloadWidget(card)"
              />
            </div>
          </template>
        </solicitacao-listagem>
      </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoListagem from '@/components/TemplateSolicitacao/SolicitacaoListagem'
import ListaExtratoCard from '@/components/TemplateSolicitacao/componentes/ListaExtratoCard'
import { preloadWidget } from '@/views/10/PreLoadWidget10'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'

export default {
  components: { ListaExtratoCard, FuncionalidadeHeader, SolicitacaoListagem },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade', 'embedJson']),
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapGetters('SetupApp', ['isWidget', 'canalAtendimentoOrigem']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    listaComData () {
      let data = []
      this.contratosList.map((obj) => {
        const tempLista = obj.extrato.map((el) => {
          let data = el.dataSolicitacao
          let timestamp = new Date(data).getTime()
          return {
            ...el,
            data_registro: timestamp,
            cardExterno: true
          }
        })
        data.push({
          numeroContrato: obj.numeroContrato,
          extrato: tempLista
        })
      })
      return data
    },
    rotaNovo () {
      return `/${this.funcionalidade.idFuncionalidade}/novo`
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  },
  methods: {
    async init () {
      await this.listaExtratos()
    },
    async listaExtratos () {
      const range = this.funcionalidade.parametros.rangeDataListaReembolso
      const hoje = new Date()
      const dataInicial = new Date(hoje)
      dataInicial.setMonth(dataInicial.getMonth() - range)
      const dataFinal = new Date(hoje)
      dataFinal.setMonth(dataFinal.getMonth() + range)
      const formatarData = data =>
        data.toISOString().split('T')[0]

      let result = await this.apiFuncionalidade.lista({
        payload: {
          dataInicial: formatarData(dataInicial),
          dataFinal: formatarData(dataFinal)
        },
        handlerErrorIgnore: true
      })
      this.contratosList = result.data.contratos
    },
    onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idOcorrencia: row['idReembolso'],
              idGuia: row['numeroGuiaReembolso']
            }
          })
      }
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente,
        this.aplicacao
      )
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
#func-10 {
  .sub {
    font-size: 11px;
    color: #555555;
    margin: 0;
    font-weight: 400;
  }
  .main {
    padding: 20px;
  }
  .listagem-extrato-reembolso {
    border-left: 5px solid var(--situacao-cor);
    border-radius: 6px;
  }
  .situacao-card {
    color: var(--situacao-cor)
  }
}
</style>
